import { gql } from '@apollo/client'

const BASE_ADDITIONAL_TEST_FIELDS = gql`
  fragment BaseAdditionalTestFields on AdditionalTestType {
    id
    stripeProductId
    name
    description
    subject {
      id
      tabName
      slug
      platform {
        id
        slug
        title
      }
    }
    type
    practiceTests {
      id
    }
    status
    price
    isMostPopular
    ligthModeImageUrl
    darkModeImageUrl
    active
    rewardIdx
  }
`

export const FIND_ALL_ADDITIONAL_TESTS = gql`
  ${BASE_ADDITIONAL_TEST_FIELDS}
  query findAllAdditionalTests($query: AdditionalTestQueryInput!) {
    findAllAdditionalTest(query: $query) {
      items {
        ...BaseAdditionalTestFields
      }
      count
    }
  }
`

export const UPDATE_ADDITIONAL_TEST = gql`
  ${BASE_ADDITIONAL_TEST_FIELDS}
  mutation updateAdditionalTest($updateAdditionalTestInput: UpdateAdditionalTestInput!) {
    updateAdditionalTest(updateAdditionalTestInputFieldName: $updateAdditionalTestInput) {
      ...BaseAdditionalTestFields
    }
  }
`

export const FIND_ADDITIONAL_TEST = gql`
  ${BASE_ADDITIONAL_TEST_FIELDS}
  query findOneAdditionalTest($additionalTestId: String!) {
    findOneAdditionalTest(id: $additionalTestId) {
      ...BaseAdditionalTestFields
    }
  }
`
